import React from 'react';
import { Permission } from "./Types";
import usePermission from "./usePermission";

type Props = {
    to: Permission;
    fallback?: JSX.Element | string;
    loadingComponent?: JSX.Element | string;
    alternativeComponent?: any
};

const Restricted: React.FunctionComponent<Props> = ({ to, fallback, loadingComponent, children, alternativeComponent }) => {

    const [loading, allowed] = usePermission(to);
    if (loading) {
        return <>{loadingComponent}</>;
    }
    if (alternativeComponent && allowed)
        return <>{alternativeComponent}</>

    else if (alternativeComponent) {
        return <>{children}</>
    }

    if (allowed) {
        return <>{children}</>;
    }

    return <>{fallback}</>;
};

export default Restricted;
